var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table',{staticClass:"table table-striped table-bordered"},[_c('tbody',[_c('tr',[_c('td',[_vm._v("Display Phone Number")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.metadata.display_phone_number || 'Undefined'))])])])]),_vm._v(" "),_c('PageTemplates',{attrs:{"connection-id":_vm.id}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f8769d8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Integrations/connectors/whatsapp/Page.vue
// module id = null
// module chunks = 